/* eslint-disable */
/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueGtag from "vue-gtag";
import { Auth0Plugin } from './auth';

Vue.use(Vuesax)

const blockToastDismiss = (toastEl) => {
  if (!toastEl || toastEl.dataset.dismissLocked === 'true') return
  const stopDismiss = (event) => {
    event.stopImmediatePropagation()
  }
  ;['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach((eventName) => {
    toastEl.addEventListener(eventName, stopDismiss, true)
  })
  toastEl.dataset.dismissLocked = 'true'
  toastEl.classList.add('persistent-error-toast')
}

const installPersistentErrorToasts = (vs) => {
  if (!vs || typeof vs.notify !== 'function' || vs.__persistentErrorPatchInstalled) return
  const originalNotify = vs.notify.bind(vs)
  vs.notify = (options = {}) => {
    const normalizedOptions = { ...options, fixed: true, time: 0 }

    originalNotify(normalizedOptions)

    setTimeout(() => {
      const toasts = document.querySelectorAll('.vs-notifications')
      toasts.forEach(blockToastDismiss)
    }, 0)
  }
  vs.__persistentErrorPatchInstalled = true
}

const tryInstallPersistentToasts = () => {
  installPersistentErrorToasts(Vue.prototype.$vs)
}

Vue.use(require('vue-cookies'))

Vue.use(VueCookies)
Vue.use(VeeValidate);

Vue.use(VueReCaptcha, { siteKey: '6LfFVWoUAAAAAGmWJaBlphk_B5eWDXeEqhq3wmoy' })

Vue.use(VueGtag,
  {
    config: { id: 'G-G96NP9EM43' }
  },
  router
)



// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: process.env.VUE_APP_AUTH0_AUDIENCE
  },
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

installPersistentErrorToasts(app.$vs)
tryInstallPersistentToasts()
let toastPatchAttempts = 0
const toastPatchTimer = setInterval(() => {
  tryInstallPersistentToasts()
  installPersistentErrorToasts(app.$vs)
  toastPatchAttempts += 1
  if ((Vue.prototype.$vs && Vue.prototype.$vs.__persistentErrorPatchInstalled) || toastPatchAttempts >= 40) {
    clearInterval(toastPatchTimer)
  }
}, 100)
